
export abstract class Singleton {
    protected static instance: any;

    protected constructor() {};

    public static getInstance<T>(): T {
        if (!this.instance) {
            // @ts-ignore
            this.instance = new this();
        }
        return this.instance;
    }
}
